
import {
  defineComponent, onUnmounted, ref, watch,
} from 'vue';
import DigitalTransform from '@/components/Public/DigitalTransform/DigitalTransform.vue';

export default defineComponent({
  components: {
    aDigitalTransform: DigitalTransform,
  },
  props: {
    value: {
      type: Number,
      default: 0,
      required: true,
    },
    unit: {
      type: String,
      default: '',
    },
    seperator: {
      type: Boolean,
      default: false,
    },
    interval: {
      type: Number,
      default: 500,
    },
    plusColor: {
      type: String,
      default: 'red',
    },
    reduceColor: {
      typp: String,
      default: 'limegreen',
    },
  },
  setup(props) {
    /** var */
    const isShow = ref(false);
    const changeValue = ref(0);
    let animatingTimer: undefined|number; /** 防抖 */
    /** method */
    /** 防抖 */
    const digitalDebounce = () => {
      if (animatingTimer) {
        clearTimeout(animatingTimer);
      }
      isShow.value = true;
      animatingTimer = setTimeout(() => {
        isShow.value = false;
        animatingTimer = undefined;
      }, 1500);
    };
    /** 判断符号 */
    const isPlus = (testVal: number, isSep: boolean) => {
      // 判断是否为带有千分位符选项
      if (isSep) {
        const changeStr = testVal
          .toString()
          .replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','));
        const result = changeStr.split('').join('');
        const first = changeStr.split('')[0];
        if (first.match(/^[0-9]$/)) {
          return `+${result}`;
        }
        return result;
      }
      if (testVal > 0) {
        return `+${testVal}`;
      }
      return testVal;
    };
    /** destroy */
    onUnmounted(() => {
      clearTimeout(animatingTimer);
    });
    /** watch */
    watch(
      () => props.value,
      (newVal, oldVal) => {
        changeValue.value = (isPlus(newVal - oldVal, props.seperator) as number);
        digitalDebounce();
      },
      { deep: true },
    );

    return {
      isShow,
      changeValue,
    };
  },
});
